ACC.quotes.details = {
    init: function () {
        ACC.quotes.details.initOverlayButton('#requestChange', function () {
            ACC.quotes.overlay.addCloseButtonHandler('#abortButton');
            ACC.quotes.overlay.addSendButtonHandler('#sendButton', '#abortButton', '#overlayChangeRequest');
        }, false);

        ACC.quotes.details.initOverlayButton('#decline', function () {
            ACC.quotes.overlay.addCloseButtonHandler('#abortButton');
            ACC.quotes.overlay.addSendButtonHandler('#sendButton', '#abortButton', '#overlayDecline');
        }, false);

        ACC.quotes.details.initOverlayButton('#accept', function () {
            ACC.quotes.overlay.addCloseButtonHandler('#abortButton');
            ACC.quotes.overlay.addSendButtonHandler('#sendButton', '#abortButton', '#overlayAccept');
        }, false);

        ACC.quotes.details.initOverlayButton('#requestChangeBackend', function () {
            ACC.quotes.overlay.addCloseButtonHandlerForResetQuote('#abortButton', '#quoteDetailsForm');
        }, true);

        ACC.quotes.details.initOverlayButton('#requestableForUpdate', function () {
            ACC.quotes.overlay.addCloseButtonHandler('#abortButton');
            ACC.quotes.overlay.addSendButtonHandler('#sendButton', '#abortButton', '#overlayRequestForUpdate');
        }, false);

        ACC.quotes.setStatusAlternativePositions();
    },
    initOverlayButton: function (buttonSelector, onCompleteCallback, showSpinner) {
        var button = $(buttonSelector);

        button.on('click', function (e) {

            ACC.quotes.setPageButtonPropertyDisabled(true);

            var url = button.attr('data');
            e.preventDefault();

            if (!url) {
                return;
            }

            // copy radio boxes into the form to send them  back to server
            var $form = $(this).closest('form');
            copyAlternatePositionToForm($form);

            $.ajax(url, {
                type: 'POST',
                dataType: 'html',
                data: $form.serialize(),
                beforeSend: function () {
                    if (showSpinner) {
                        button.showSpinner();
                        button.prop("disabled", true);
                    }
                },
                success: function (data) {
                    $.colorbox({
                        width: false,
                        innerHeight: "340",
                        escKey: false,
                        overlayClose: false,
                        innerWidth: ACC.quotes.overlay.innerWidth,
                        html: $(data),
                        scrolling: false,
                        onLoad: function () {
                            $('#cboxClose').remove();
                        },
                        onComplete: function () {
                            $.colorbox.resize();

                            onCompleteCallback();
                        }
                    });
                }
            });
        });
    }
};

ACC.quotes.overlay = {
    innerWidth: "560px",
    addCloseButtonHandler: function (buttonSelector) {
        var button = $(buttonSelector);

        button.on('click', function (e) {
            e.preventDefault();
            $.colorbox.close();
            ACC.quotes.setPageButtonPropertyDisabled(false);
        });
    },
    addCloseButtonHandlerForResetQuote: function (buttonSelector, nextURLSelector) {
        var button = $(buttonSelector);

        button.on('click', function (e) {
            e.preventDefault();
            $.colorbox.close();
            ACC.quotes.setPageButtonPropertyDisabled(false);
            window.location.href = $(nextURLSelector).attr('data-nextURL');
        });
    },

    addSendButtonHandler: function (sendButtonSelector, abortButtonSelector, overlaySelector) {
        var $sendButton = $(sendButtonSelector);

        $sendButton.on('click', function (e) {

            // copy radio boxes into the form to send them  back to server
            var $form = $(this).closest('form');
            copyAlternatePositionToForm($form);

            // disable sendButton and page buttons
            $sendButton.prop('disabled', true);
            ACC.quotes.setPageButtonPropertyDisabled(true);

            var url = $sendButton.attr('data');
            e.preventDefault();

            if (!url) {
                return;

            }

            // Trigger accept quote processing
            $.ajax(url, {
                type: 'POST',
                dataType: 'html',
                data: $sendButton.parents('form').serialize(),
                success: function (data) {

                    var originalCloseFunction = $.colorbox.close;
                    // Prevents the closing of the overlay and does a reload in case of this specific overlay.
                    $.colorbox.close = function () {
                        var continueUrl = $('#continueUrl');
                        if (continueUrl.length) {
                            window.location.href = continueUrl.attr('value');
                            return;
                        }
                        originalCloseFunction();
                    };


                    $.colorbox({
                        html: $(data),
                        scrolling: false,
                        width: false,
                        innerHeight: "340",
                        escKey: false,
                        overlayClose: false,
                        innerWidth: ACC.quotes.overlay.innerWidth,
                        onLoad: function () {
                            $('#cboxClose').remove();
                        },
                        onComplete: function () {
                            $.colorbox.resize();

                            ACC.quotes.overlay.addCloseButtonHandler(abortButtonSelector);

                            if ($(overlaySelector).length) {
                                ACC.quotes.overlay.addSendButtonHandler(sendButtonSelector, abortButtonSelector, overlaySelector);
                            }
                        }
                    });

                },

                error: function () {
                    $.colorbox.close();
                }
            });
        });
    }
};

ACC.quotes.setPageButtonPropertyDisabled = function (prop) {
    $('#requestChange').prop('disabled', prop);
    $('#decline').prop('disabled', prop);
    $('#accept').prop('disabled', prop);
    $('#requestChangeBackend').prop('disabled', prop);
};

ACC.quotes.setStatusAlternativePositions = function () {

    $('.js-selected-alternate-position').on('change', function () {

        var $this = $(this),
            // get ID
            altPosID = $this.attr('ID'),
            //extract the Position Number
            altPos = $(this).attr('name').match(/\d+/),
            // extract the name without the square brackets and the position number
            altPosName = $this.attr('name').match(/[a-zA-Z]+/g),
            // merge altPos + altPosName
            altPosMerge = altPosName + '\\' + '[' + altPos + '\\' + ']',
            // get all other alt. Position of this group
            $altPosGroup = $(".js-merchant-items input[type=radio][name=" + altPosMerge + "]"),
            // remove clicked alternative Position from Group
            resultGroup = $.grep($altPosGroup, function (e) {
                return e.id != altPosID;
            });

        //reset all Group Items (remove grey scaling)
        $($altPosGroup).each(function () {
            $(this).closest('.row').find('.col').removeClass('grey-scaling');
        });

        //grey scaling result Group Items
        $(resultGroup).each(function () {
            $(this).closest('.row').find('.col').addClass('grey-scaling');
        });

        // disable sendButton and page buttons
        ACC.quotes.setPageButtonPropertyDisabled(true);

        // copy radio boxes into the form to send them  back to server
        var $form = $('#quoteDetailsForm');
        copyAlternatePositionToForm($form);
        // update the selected alternatives by changing the form url
        $form.prop('action', $form.attr('data-updateAlternativesUrl'));

        $form.submit();

    });


};

ACC.quotes.deliveryaddress = {

    init: function () {
        if ($(".js-quote-details-address").length > 0) {
            ACC.quotes.deliveryaddress.getAndShow($(".js-quote-details-address").attr("data-address-id"));
        }
    },

    getAndShow: function (addressId) {
        var $quoteAddress = $(".js-summaryDeliveryAddressQuote");
        if ($quoteAddress.length != 1 || !$quoteAddress.attr("data-get-selected")) {
            return;
        }

        $.getJSON($quoteAddress.attr("data-get-selected"),
            {
                addressId: addressId
            },
            function (addresses) {

                var cartData = {
                    deliveryAddress: addresses
                };

                $(".summaryDeliveryAddress .contentSection").html(
                    $.templates('.summaryDeliveryAddress .sectionTemplateQuote').render({
                        data: cartData
                    })
                );


                $(document).on("click", '.summaryDeliveryAddress .editButtonQuote', function () {

                    var openColorBox = function () {
                        $.colorbox({
                            inline: true,
                            href: "#summaryDeliveryAddressOverlay",
                            height: false,
                            innerWidth: "890px",
                            onLoad: function () {
                                $('#cboxClose').remove();
                            },
                            onComplete: function () {
                                ACC.checkoutB2B.validateDeliveryAddressPopUp();
                                $.colorbox.resize();
                            },
                            onClosed: function () {
                                ACC.common.refreshScreenReaderBuffer();
                            }
                        });
                    };

                    var changeFormUrl = $(this).closest(".js-summaryDeliveryAddressQuote").data('get-form') + "?createUpdateStatus=1&addressId=" + addressId;
                    var getUrl = $(this).closest(".js-summaryDeliveryAddressQuote").data('get');

                    ACC.quotes.deliveryaddress.showAddressForm(changeFormUrl, getUrl, openColorBox, addressId);
                });

            });

    },


    showAddressForm: function (changeFormUrl, getUrl, openColorBox, addressId) {

        $.get(changeFormUrl, function (data) {

            $("#summaryDeliveryAddressForm").remove();
            $("#summaryDeliveryAddressOverlay").prepend(data);
            $("#summaryDeliveryAddressForm #defaultDeliveryAddressId").val($("#addressDropdownSelect option:selected").attr("data-address"));

            $.getJSON(getUrl,
                {
                    addressId: addressId
                }, function (data) {
                    section = ".summaryDeliveryAddress";

                    openColorBox();
                });
        });
    }

};

function copyAlternatePositionToForm($form) {
    $form.find('.js-selected-alternate-position').remove();
    var $selectedAlternatePosition = $('.js-order-entry .js-selected-alternate-position').clone();
    $selectedAlternatePosition.hide();
    $form.append($selectedAlternatePosition);
}


ACC.quotes.declineButton = {

    init: function () {

        $('.js-quote-decline-position').on('click', function () {

            var $form = $('#quoteDetailsForm');
            $form.prop('action', $(this).attr("data-url"));
            $form.submit();
        });
        $('.js-quote-accept-position').on('click', function () {

            var $form = $('#quoteDetailsForm');
            $form.prop('action', $(this).attr("data-url"));
            $form.submit();
        });
        $('.js-quote-reset-position').on('click', function (e) {

            var url = $(this).attr('data-url');
            e.preventDefault();

            if (!url) {
                return;
            }

            $.ajax(url, {
                type: 'GET',
                dataType: 'html',
                success: function (data) {
                   location.reload();
                }
            });
        });
    }
};

ACC.quotes.handleAddNewEntryLineButton = function () {
    var counter = 1;
    $(document).on("click", '.js-add-item-send', function (e) {
        $(".js-add-item-send").prop('disabled', true);
        e.preventDefault();
        var $addItemSelector = $('.js-add-item-send'),
            url = $addItemSelector.attr('data'),
            urlValidation = $addItemSelector.attr('data-validate'),
            productList = [],
            quantityList = [];

        for (var i=1;i<=counter;i++) {
            productList.push($("#variantCode" + i).val());
        }
        for (var j=1;j<=counter;j++) {
            quantityList.push($("#quantity" + j).val());
        }

        $.ajax({
            async: false,
            type: "POST",
            dataType: 'json',
            contentType : 'application/json',
            url: urlValidation,
            data: JSON.stringify({
                products: productList,
                quantities: quantityList
            }),
            error: function(data,status) {
            },
            success: function(data,status) {
                for (var i=1;i<=counter;i++) {
                   $("#variantError"+i).text("");
                   $("#quantityError"+i).text("");
                   $("#errorRow"+i).addClass("hide");
                }
                if (data.isValid === false) {
                    for (var j=0;j<counter;j++) {
                       if (data.errorsProducts[j].length > 0) {
                           $("#variantError"+(j+1)).text(data.errorsProducts[j]);
                           $("#errorRow"+(j+1)).removeClass("hide");
                       }
                       if (data.errorsQuantities[j].length > 0) {
                           $("#quantityError"+(j+1)).text(data.errorsQuantities[j]);
                           $("#errorRow"+(j+1)).removeClass("hide");
                       }
                    }
                    $(".js-add-item-send").prop('disabled', false);
                    parent.$.colorbox.resize();
                } else {
                    $.ajax({
                        async: false,
                        type: "POST",
                        dataType: 'json',
                        contentType : 'application/json',
                        url: url,
                        data: JSON.stringify({
                            products: productList,
                            quantities: quantityList
                        }),
                        error: function(data,status) {
                        },
                        success: function(data,status) {
                        }
                    });
                    parent.$.colorbox.close();
                    location.reload();
                }
            }
        });
    });
    $(document).on("click", '.js-change-quantity', function (e) {
        e.preventDefault();

        var $addItemSelector = $('.js-change-quantity')
        var url = $addItemSelector.attr('data') ;
        var urlValidation = $addItemSelector.attr('data-validation');

        $.ajax({
            async: false,
            type: "POST",
            dataType: 'json',
            contentType : 'application/json',
            url: urlValidation,
            data: JSON.stringify({
                qty: $("#quantity").val(),
                unitCode: $("#srcUnit").val()
            }),
            error: function(data,status) {
            },
            success: function(data,status) {
                if (data.errorMsg != "") {
                   $("#errorMsg").text(data.errorMsg);
                   $("#errorRow").removeClass("hide");
                } else {
                   $("#errorMsg").text("");
                   $("#errorRow").addClass("hide");

                    $.ajax({
                        async: false,
                        type: "POST",
                        dataType: 'json',
                        contentType : 'application/json',
                        url: url,
                        data: JSON.stringify({
                            qty: $("#quantity").val(),
                            unitCode: $("#srcUnit").val()
                        }),
                        error: function(data,status) {
                        },
                        success: function(data,status) {
                        }
                    });
                    parent.$.colorbox.close();
                    location.reload();
                }
            }
        });
    });
    $(document).on("click", '#add-entry-button', function (e) {
        e.preventDefault();
        counter++;
        var lastInputGroup = $('.add-entry-input-group:nth-last-of-type(1)'),

            wrapper2 = $('<tr></tr>')
                .attr("id", "errorRow" + counter)
                .addClass('hide')
                .addClass('error'),
            errorVariant = $('<td></td>').append(
                $("<span />")
                    .attr("id", "variantError" + counter)),
            errorQuantity = $('<td></td>').append(
                $("<span />")
                    .attr("id", "quantityError" + counter)),
            newEntryErrors = wrapper2.append(errorVariant, errorQuantity)

            wrapper = $('<tr></tr>')
            .addClass('add-entry-input-group'),
            tdVariantCode = $('<td></td>').append(
                $("<input type='text' />")
                    .addClass('add-entry-input-field')
                    .attr("id", "variantCode" + counter)
                    .attr("name", "entry[" + counter + "][variantCode]")),
            tdQuantity = $('<td></td>').append(
                $("<input type='text' />")
                    .addClass('add-entry-input-field')
                    .attr("id", "quantity" + counter)
                    .attr("name", "entry[" + counter + "][quantity]")),
            newEntryLine = wrapper.append(tdVariantCode, tdQuantity)


        lastInputGroup.after(newEntryErrors);
        newEntryErrors.after(newEntryLine);
        parent.$.colorbox.resize();

    });
};


ACC.quotes.changeQuantityButton = {

    init: function () {

        var button = $('.js-quote-change-quantity');

        button.on('click', function (e) {

            var url = $(this).attr('data-url');
            e.preventDefault();

            if (!url) {
                return;
            }

            $.ajax(url, {
                type: 'GET',
                dataType: 'html',
                success: function (data) {
                    ACC.quotes.setPageButtonPropertyDisabled(true);
                    $.colorbox({
                        width: false,
                        innerHeight: "340",
                        innerWidth: ACC.quotes.overlay.innerWidth,
                        html: $(data),
                        scrolling: false,
                        trapFocus: true,
                        onLoad: function () {
                            $('#cboxClose').remove();
                        },
                        onComplete: function () {
                            $.colorbox.resize();
                            ACC.quotes.overlay.addCloseButtonHandler('#abortButton');
                            KMVP.tooltips.bindTooltips($('#colorbox'));
                        },
                        onClosed: function () {
                            ACC.common.refreshScreenReaderBuffer();
                        }
                    });
                }
            });
        });
    }



};


ACC.quotes.addEntryButton = {

    init: function () {

        var button = $('.js-quote-add-entry');

        button.on('click', function (e) {

            ACC.quotes.setPageButtonPropertyDisabled(true);

            var url = button.attr('data-url');
            e.preventDefault();

            if (!url) {
                return;
            }

            $.ajax(url, {
                type: 'GET',
                dataType: 'html',
                success: function (data) {
                    $.colorbox({
                        width: false,
                        innerHeight: "340",
                        innerWidth: ACC.quotes.overlay.innerWidth,
                        html: $(data),
                        scrolling: false,
                        onLoad: function () {
                            $('#cboxClose').remove();
                        },
                        onComplete: function () {
                            $.colorbox.resize();
                            ACC.quotes.overlay.addCloseButtonHandler('#abortButton');
                        },
                        onClosed: function () {
                            ACC.common.refreshScreenReaderBuffer();
                        }
                    });
                }
            });
        });
    }



};



$(document).ready(function () {
    ACC.quotes.details.init();
    ACC.quotes.deliveryaddress.init();
    ACC.quotes.declineButton.init();
    ACC.quotes.changeQuantityButton.init();
    ACC.quotes.addEntryButton.init();
});
